/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaEnableVerifyPost200Response
 */
export interface MfaEnableVerifyPost200Response {
    /**
     * 
     * @type {string}
     * @memberof MfaEnableVerifyPost200Response
     */
    message?: string;
}

export function MfaEnableVerifyPost200ResponseFromJSON(json: any): MfaEnableVerifyPost200Response {
    return MfaEnableVerifyPost200ResponseFromJSONTyped(json, false);
}

export function MfaEnableVerifyPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaEnableVerifyPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function MfaEnableVerifyPost200ResponseToJSON(value?: MfaEnableVerifyPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

